import script from "./SalesSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesSelector.vue?vue&type=script&setup=true&lang=ts"

import "./SalesSelector.vue?vue&type=style&index=0&id=8a1f0004&scoped=true&lang=css"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a1f0004"]])

export default __exports__